import { createContext } from "react";

import { PropTypes } from "prop-types";

import useLazyContentSettingsGroupsGet from "@/admin/hooks/useLazyContentSettingsGroupsGet";

export const ContentSettingsGroupsContext = createContext();

const propTypes = {
  children: PropTypes.any,
};

const ContentSettingsGroupsProvider = ({ children }) => {
  const [
    fetchContentSettingsGroups,
    {
      data: contentSettingsGroups,
      loading: contentSettingsGroupsAreLoading,
      error: isErrorRetrievingContentSettingsGroups,
    },
  ] = useLazyContentSettingsGroupsGet({ include_archived: true });

  const sharedContext = {
    fetchContentSettingsGroups,
    contentSettingsGroups,
    contentSettingsGroupsAreLoading,
    isErrorRetrievingContentSettingsGroups,
  };

  return (
    <ContentSettingsGroupsContext.Provider value={sharedContext}>
      {children}
    </ContentSettingsGroupsContext.Provider>
  );
};

ContentSettingsGroupsProvider.propTypes = propTypes;

export default ContentSettingsGroupsProvider;
